/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-types */
import { Grid } from '@material-ui/core'
import React from 'react'
import { renderCol } from '@flatsy/utils/Functions/form/Helpers'
import renderSingleField from './Field'
import { makeGroup } from './Utils'
import Condition from '../Condition'
import { IFieldContainer } from './Type'
import { FieldsType } from '../../Types'

const FieldsContainer = <T extends {}>({
  fields,
  layout,
  values,
  justSubmitted,
}: IFieldContainer<T>): React.ReactElement => {
  const Item = ({ field }: { field: FieldsType }) => (
    <Grid
      item
      alignContent={field.alignContent}
      alignItems={field.alignItems}
      xs={renderCol(field, true)}
      sm={field.conditional ? field.conditional(values).col : renderCol(field, false)}
      hidden={field.conditional ? field.conditional(values).hidden : undefined}
      key={`grid-${field.type}-${field.name}${field.complexKey ? `-${field.complexKey}` : ''}`}
    >
      {renderSingleField(field, values, justSubmitted)}
    </Grid>
  )

  const IsConditional = ({ field }: { field: FieldsType }) =>
    field.conditionalField ? (
      <Condition
        {...field.conditionalField}
        values={values}
        key={`condition-${field.type}-${field.name}${
          field.complexKey ? `-${field.complexKey}` : ''
        }`}
      >
        {Item({ field })}
      </Condition>
    ) : (
      Item({ field })
    )

  if (layout) {
    const groups = makeGroup(fields, layout)
    return (
      <>
        {groups.map((group) => (
          <Grid
            container
            spacing={1}
            className={group.className}
            id={group.group}
            key={`group-${group.group}`}
          >
            {group.fields.map((field) => IsConditional({ field }))}
          </Grid>
        ))}
      </>
    )
  }
  return <>{fields.map((field) => IsConditional({ field }))}</>
}

export default FieldsContainer
